const VERSION = '3.12.1';
export default VERSION;
